import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { JSONResponse } from '../../../NonReact/common/Types/Types'
import { AkixiEntities } from '../../../NonReact/constants/AkixiEntities'
import { APIPathParams, getAPIInternalBaseURL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { URLConstructor } from '../../../NonReact/utils/URLBuilder'

const baseURL = (telsysId: number): URLConstructor =>
    getAPIInternalBaseURL().appendPathParams(AkixiEntities.TEL_SYS, telsysId, APIPathParams.SITE_SURVEY)

const startSiteSurveyURL = (telsysId: number): URLConstructor => baseURL(telsysId).addPathParams(APIPathParams.START)
export const downloadSiteSurveyURL = (telsysId: number): URLConstructor =>
    baseURL(telsysId).appendPathParams(APIPathParams.DOWNLOAD)

export const runSiteSurvey = (telsysId: number): Promise<JSONResponse<void>> =>
    requestJSON(startSiteSurveyURL(telsysId), {
        method: RESTMethods.POST
    })
